// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__3YtVP","info":"PatientInfo_info__1U2hw"};